
console.log("Smartsettle start")
import { createApp, h } from 'vue';
import store from "store/index";
//import { createPinia } from 'pinia';
import Quadro from 'quadro'
import MyI18n from 'plugins/my_i18n'
import { createI18n } from 'vue-i18n/dist/vue-i18n.esm-bundler.js';
import bootstrapCss from 'bootstrap/dist/css/bootstrap.min.css'

const i18n = createI18n({
  locale: 'en', // default locale
  fallbackLocale: 'en', // fallback locale
  globalInjection: true, // Allows using $t in templates without explicit import
});
//const pinia = createPinia();
export default class SmartsettlePanel {
  constructor(elementId, apiEndpoint, caseId, ...args) {
    let credentials
    let options
    console.log("Smartsettle constructor")
    if (args[0] && args[1]) {
      credentials = {username: args[0], apiKey: args[1]}
      options = args[3]
    } else {
      options = args[0]
    }
    if (options?.locale) {
      i18n.locale = options.locale
    }

    const host = document.getElementById("slider-container")
    const shadowRoot = host.attachShadow({ mode: 'open' })

    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css'
    shadowRoot.appendChild(link)
    const style = document.createElement('style')
    style.textContent = `
      :host {
        position: relative;
        z-index: 9999;
      }

      #modal-root {
        position: relative;
        z-index: 9999;
      }

      .modal {
        z-index: 10001;
      }

    `
    const linkcss = document.createElement('link')
    linkcss.rel = 'stylesheet'
    linkcss.href = 'https://beta.smartsettle.com/assets/application.css'  
    shadowRoot.appendChild(linkcss)
    shadowRoot.appendChild(style)
 
    const appRoot = document.createElement('div')
    appRoot.id = 'app-root'

    const modalRoot = document.createElement('div')
    modalRoot.id = 'modal-root'

    shadowRoot.append(appRoot, modalRoot)


    this.parent = createApp({
      data(){ return {options}; },
      render: () => h(Quadro, {apiEndpoint: apiEndpoint, caseId: caseId, credentials: credentials})
    })
    this.parent.config.productionTip = false
    //this.parent.use(pinia)
    console.log("smartsettle_panel - store")
    console.log(store)
    this.parent.use(store)
    this.parent.use(MyI18n)
    this.parent.provide('modalRoot', modalRoot).mount(appRoot)
  }
}

//export default SmartsettlePanel
